import React from "react";
import { MAX_ATTEMPTS } from "./HelpersFunctions";
import TokenGlyph from "./TokenGlyph";

const Grid = ({nameOfTheDay, attemptDict, answerDictionaryState}) => {
    // Generate row keys dynamically
    const rowKeys = Array.from({length: MAX_ATTEMPTS}, (_, i) => i + 1);

    return(
        <div className="full-grid">
            {rowKeys.map((rowKey) =>
                <div key={rowKey} className="grid-row">
                    {attemptDict[rowKey].map((char, index) =>
                        <p
                            className={`single-grid ${answerDictionaryState[rowKey] === null ? '' : answerDictionaryState[rowKey][index]}`}
                            key={index}
                        >
                            <TokenGlyph token={char} />
                        </p>
                    )}
                </div>
            )}
        </div>
    )
}

export default Grid;
